module.exports = __webpack_public_path__ + "static/s6-icons-b8dcfa8d69de5dd60c02db86d6030181.png";